import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "../services/translate.service";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Pipe({
    name: 'translate',
    standalone: false
})
export class TranslatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) { }

  transform(key: any): Observable<string> {
    return this.translateService.translate(key).pipe(
      map((keyValue) => {
        return keyValue;
      })
    );
  }

}